import { createFileRoute } from "@tanstack/react-router";
import { AdminDashboardShell } from "@/components/layout/AdminDashboardShell";
import { UserSearchPage } from "@/features/user-search";
import { usersSearchSchema } from "@/features/user-search/user-route-search";

export const Route = createFileRoute("/users/")({
  validateSearch: usersSearchSchema,
  component: UsersRoute,
});

function UsersRoute() {
  return (
    <AdminDashboardShell>
      <UserSearchPage />
    </AdminDashboardShell>
  );
}
